(function($) {
$(document).ready(function () {


  // Some times you get random p tags that create space

  $('p:empty').remove();

  $('p').each(function() {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
      $this.remove();
  });


  // Active Class on Nav

  // $(function($) {
  //   var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  //   console.log(path)
  //   $('.navigation li a').each(function() {
  //     if (this.href === path) {
  //       $(this).addClass('active');
  //     }
  //   });
  //   // For single posts losing scope
  //   if (window.location.href.indexOf('guidance') > 0) {
  //     $(".guidance").find(".parent_link").addClass('active');
  //   }
  // });

  // $(".mobile_filter_btn").on("click", function() { 
  //   $(".hidden_filters").toggleClass("active");  
  // });

  // $(".mobile_title").on("click", function() { 
  //   $(".brochure_form").toggleClass("active");   
  // });


  
  // Accordion


$(document).ready(function() {
  $(".tab_inner").on("click", function() {
    //console.log("Clicked tab");
    $(this).next(".content").toggleClass("active"); 
    $(this).find(".arrow").toggleClass("turn_arrow");  
  });
});

 // Show mini cart

 $(document).ready(function () {
    $(".cart").click(function () {
      $(this).next().toggleClass("active");
    });
  });

 $('.scroll_to').click(function(e){
    var jump = $(this).attr('href');
    var new_position = $(jump).offset();
    $('html, body').stop().animate({ scrollTop: new_position.top }, 500);
    e.preventDefault();
});


$(document).ready(function () {
  $(".mens_title").click(function () {
    $(".facet_mens").toggleClass("active");
    $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".womens_title").click(function () {
    $(".facet_womens").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".accessories_title").click(function () {
    $(".facet_accessories").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".color_title").click(function () {
    $(".facet_color").toggleClass("active");
    $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".style_title").click(function () {
    $(".facet_style").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".mens_size_title").click(function () {
    $(".facet_mens_sizes").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".womens_sizes_title").click(function () {
    $(".facet_womens_sizes").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".womens_sizes_title").click(function () {
    $(".womens_mens_sizes").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".mens_sizes_title").click(function () {
    $(".facet_mens_sizes").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".filter_button").click(function () {
    $(".cat_wrapper").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".blog_cat_title").click(function () {
    $(".facet_blog_cat").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".blog_archive_title").click(function () {
    $(".facet_blog_archive").toggleClass("active");
     $(this).find(".arrow").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".facet_blog_cat").addClass("active");
});




// Show and hide faqs

$(".sector_inner").on("click", function() {
  var sectors_to_show = $(this).attr("data-attr");

  $(".sector_inner").removeClass("active_sector"); 
  $(this).addClass("active_sector");

  $(".faq_contents .active_hidden_section").removeClass("active_hidden_section fadeOut");
  $("." + sectors_to_show).addClass("active_hidden_section fadeIn");
});

//Home page

$(".banner_slider_wrapper .sector_inner").on("click", function() {
  var sectors_to_show = $(this).attr("data-attr");


  $(".sector_inner").removeClass("active_sector");
  $(this).addClass("active_sector");


  $(".active_hidden_section").removeClass("active_hidden_section fadeOut");
  $("." + sectors_to_show).addClass("active_hidden_section fadeIn");
});


});
})(jQuery); 



